function openPopup() {
    document.body.classList.add('overlay');
    document.querySelector('.popup.main').classList.add('show');
    centerPopup();
}

function openPopupThanks() {
    document.body.classList.add('overlay');
    document.querySelector('.popup.thanks').classList.add('show');
    centerPopup();
}

document.addEventListener('DOMContentLoaded', function () {
    const popupLinks = document.querySelectorAll('.showPopup');

    popupLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            openPopup();
        });
    });
});

document.addEventListener('wpcf7mailsent', function (event) {
    document.querySelector('.popup.show .close')?.click();
    setTimeout(openPopupThanks, 200);
}, false);

// openPopup();

function closePopup(event) {
    const popup = event.target.closest('.popup');
    if (popup) {
        popup.classList.remove('show');
    }

    if (!document.querySelector('.popup.show')) {
        document.body.classList.remove('overlay');
    }
}

function centerPopup() {
    const popup = document.querySelector('.popup.show');
    if (!popup) {
        return;
    }

    const popupHeight = popup.offsetHeight;
    const windowHeight = window.innerHeight;

    if (popupHeight > windowHeight) {
        popup.style.top = `${20 + window.scrollY}px`;
        window.removeEventListener('scroll', centerPopup);
        return;
    }

    const top = (windowHeight - popupHeight) / 2 + window.scrollY;
    popup.style.top = `${top}px`;
}


window.addEventListener('resize', centerPopup);
window.addEventListener('scroll', centerPopup);

// document.querySelector('.open-popup-button').addEventListener('click', openPopup);

document.addEventListener('DOMContentLoaded', function () {
    const closeButtons = document.querySelectorAll('.close');

    closeButtons.forEach(button => {
        button.addEventListener('click', closePopup);
    });
});

//NAVIGATE
document.addEventListener('DOMContentLoaded', function () {
    const menu = document.querySelector('.navigate');
    const sections = document.querySelectorAll('.section');

    function checkSectionPosition() {
        let currentClass = '';

        sections.forEach(section => {
            const rect = section.getBoundingClientRect();
            if (rect.top <= 0 && rect.bottom > 0) {

                if (section.classList.contains('light') && currentClass !== 'light') {
                    currentClass = 'light';
                    if (!menu.classList.contains('light')) {
                        menu.classList.remove('dark');
                        menu.classList.add('light');
                    }
                } else if (section.classList.contains('dark') && currentClass !== 'dark') {
                    currentClass = 'dark';
                    if (!menu.classList.contains('dark')) {
                        menu.classList.remove('light');
                        menu.classList.add('dark');
                    }
                }
            }
        });
    }

    window.addEventListener('scroll', checkSectionPosition);
    checkSectionPosition();
});


//SUBMENU
document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.navigate-nav ul li a.has-menu');

    menuItems.forEach(item => {
        item.addEventListener('mouseenter', function () {
            const menuId = this.id;

            const submenuId = `sub${menuId}`;

            const submenu = document.getElementById(submenuId);
            if (submenu) {
                submenu.classList.add('show');
            }
        });

        item.addEventListener('mouseleave', function () {
            const menuId = this.id;
            const submenuId = `sub${menuId}`;
            const submenu = document.getElementById(submenuId);
            if (submenu) {
                submenu.classList.remove('show');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const backButton = document.querySelector('.mobile-submenu-back');

    backButton.addEventListener('click', function () {
        const parentSubmenu = this.closest('.mobile-submenu');

        if (parentSubmenu) {
            parentSubmenu.classList.remove('open');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const hasMenuLinks = document.querySelectorAll('.mobile-menu a.has-menu');

    hasMenuLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            const submenu = this.parentElement.querySelector('.mobile-submenu');

            if (submenu) {
                submenu.classList.add('open');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const menuButton = document.querySelector('.mobile-menu-btn button');
    const mobileMenu = document.querySelector('.mobile-menu');
    const navigateDiv = document.querySelector('.navigate');

    menuButton.addEventListener('click', function () {
        menuButton.classList.toggle('open');
        navigateDiv.classList.toggle('open');

        if (mobileMenu) {
            mobileMenu.classList.toggle('open');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const playButtons = document.querySelectorAll('.playButton');

    playButtons.forEach(button => {
        button.addEventListener('click', function () {
            const container = button.closest('.control-container');
            const playerDiv = container.querySelector('.control-video-player');
            const iframe = container.querySelector('.youtubePlayer');

            playerDiv.style.display = 'block';

            iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        });
    });
});

function isSafari() {
    return (navigator.vendor.match(/apple/i) || "").length > 0
}

function adjustContainerHeight() {
    const container = document.querySelector('.mobile-menu');
    const safeAreaInsetBottom = window.innerHeight - document.documentElement.clientHeight;
    // alert(safeAreaInsetBottom);
    container.style.height = `calc(100vh - 87px)`;
    if (isSafari()) {
        if (safeAreaInsetBottom == 0) {
            container.style.paddingBottom = `82px`;
        } else {
            container.style.paddingBottom = `0px`;
        }

    } else {
        container.style.paddingBottom = `0px`;
    }
}

window.addEventListener('scroll', adjustContainerHeight);
window.addEventListener('resize', adjustContainerHeight);
window.addEventListener('orientationchange', adjustContainerHeight);
adjustContainerHeight();


gsap.registerPlugin(MotionPathPlugin);

let heroTimeline = gsap.timeline({paused: true});

let isWaveAnimating = true;

function animateChart() {
    const chartLine = document.querySelector(".chart-line");
    const chartPoints = document.querySelectorAll(".chart-points");
    const chartIndicator = document.querySelectorAll(".chart-indicator path, .chart-indicator circle");
    const chartIndicatorGroup = document.querySelector(".chart-indicator");
    const chartBarRect = document.querySelector(".hero-company-ico-2");
    const chartPie = document.querySelector(".hero-company-ico-1");

    // if (!chartLine || chartPoints.length === 0 || chartIndicator.length === 0 || chartBarRect.length === 0 || !chartIndicatorGroup || !chartPie) return;


    if (
        !chartLine ||
        chartPoints.length === 0 ||
        chartIndicator.length === 0 ||
        !chartBarRect ||          // ← правильная проверка
        !chartIndicatorGroup ||
        !chartPie
    ) return;


    gsap.set(chartLine, {strokeDasharray: 3000, strokeDashoffset: 3000, opacity: 0});
    gsap.set(chartPoints, {scale: 0, opacity: 0});
    gsap.set(chartIndicator, {scale: 0, opacity: 0});


    let tl = gsap.timeline({defaults: {ease: "power2.out"}});

    tl.fromTo(".hero-company-img",
        {
            opacity: 0
        },
        {
            opacity: 1,
            duration: 1.5,
            ease: "power3.out"
        }
    );

    tl.to(chartLine, {
        opacity: 1,
        duration: .5,
        ease: "power2.out"
    });
    tl.to(chartLine, {
        strokeDashoffset: 0,
        duration: 2.5,
        ease: "power2.out"
    });

    tl.to(chartPoints, {
        scale: 1,
        opacity: 1,
        stagger: 0.2,
        duration: 0.5,
    }, "-=1.5");

    tl.to(chartIndicatorGroup, {
        duration: 0.5,
        opacity: 1,
        ease: "linear",
    });

    tl.to(chartIndicator, {
        scale: 1,
        opacity: 1,
        stagger: 0.15,
        duration: 0.7,
    }, "-=1");


    tl.to(chartIndicatorGroup, {
        scale: 1.2,
        duration: 2,
        ease: "linear",
        yoyo: true,
        repeat: -1,
        transformOrigin: "center center"
    });


    tl.fromTo(chartBarRect,
        {scale: 0, opacity: 0, y: 10},
        {
            scale: 1, opacity: 1, y: 0,
            duration: 1.2, ease: "back.out(1.7)"
        }, "-=1.5")
        .to(chartPie, {
            duration: 5,
            ease: "linear"
        });
    tl.to(chartBarRect,
        {
            scale: 1.2,
            duration: 2,
            ease: "linear",
            yoyo: true,
            repeat: -1,
            transformOrigin: "center center"
        }
    );

    tl.fromTo(chartPie,
        {scale: 0, opacity: 0, y: 10},
        {
            scale: 1, opacity: 1, y: 0,
            duration: 1.2, ease: "back.out(1.7)"
        }, "-=8.5")
        .to(chartPie, {
            duration: 5,
            ease: "linear"
        });
    tl.to(chartPie,
        {
            scale: 1.2,
            duration: 2,
            ease: "linear",
            yoyo: true,
            repeat: -1,
            transformOrigin: "center center"
        }
    );

    return tl;
}

function observeVisibility(el, callback) {
    if (!el) return;

    let observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            callback(entry.isIntersecting);
        });
    }, {threshold: 0.1});

    observer.observe(el);
}

function animateWave(selector, amplitude = 10, speed = 2) {
    let path = document.querySelector(selector);
    if (!path) return;

    let originalD = path.getAttribute("d");
    let pathCommands = originalD.match(/([a-zA-Z])|([-+]?[0-9]*\.?[0-9]+)/g);
    if (!pathCommands) return;

    let time = 0;

    function updateWave() {
        if (!isWaveAnimating) return;
        time += 0.02;

        let newD = "";
        let isY = false;

        for (let i = 0; i < pathCommands.length; i++) {
            let command = pathCommands[i];

            if (/[a-zA-Z]/.test(command)) {
                newD += command + " ";
                isY = command === "C" || command === "Q" || command === "T";
            } else {
                let value = parseFloat(command);
                if (isY) {
                    value += Math.sin(time * speed + i * 0.5) * amplitude;
                }
                newD += value.toFixed(2) + " ";
                isY = !isY;
            }
        }

        path.setAttribute("d", newD.trim());
    }


    gsap.ticker.add(updateWave);
}

function startWaveAnimation() {
    if (!isWaveAnimating) {
        // gsap.ticker.add(animateWave);
        isWaveAnimating = true;
        animateLines();
    }
}

function stopWaveAnimation() {
    if (isWaveAnimating) {
        isWaveAnimating = false;
        animateLines();
    }
}

function animateLines() {
    let line1 = document.querySelector(".hero-adv-line-1");
    let line2 = document.querySelector(".hero-adv-line-2");

    if (!line1 || !line2) return;

    gsap.set(line1, {strokeDasharray: 2000, strokeDashoffset: 2000});
    gsap.set(line2, {strokeDasharray: 3000, strokeDashoffset: 3000});

    let tl = gsap.timeline({});

    tl.to(line1, {
        strokeDashoffset: 0,
        delay: 1,
        duration: 2.5,
        ease: "power2.out"
    }).to(line2, {
        strokeDashoffset: 0,
        duration: 1.5,
        ease: "power2.out"
    }, '-=2.5');

    animateWave(".hero-adv-line-1", 8, 1.5);
    animateWave(".hero-adv-line-2", 12, 2);
}

function heroAdvAnimation() {
    const heroAdvImg1 = document.querySelector(".hero-adv-img-1");
    const heroAdvImg2 = document.querySelector(".hero-adv-img-2");
    const heroAdvImg3 = document.querySelector(".hero-adv-img-3");
    const isMobile = window.innerWidth < 992;

    heroTimeline.clear();

    if (heroAdvImg1 && !isMobile) {
        heroTimeline.to(heroAdvImg1, {
            left: -160,
            duration: 1,
            ease: "power3.out"
        }).to(heroAdvImg1, {
            x: "+=10",
            repeat: -1,
            yoyo: true,
            duration: 1.6,
            ease: "sine.inOut"
        });
    }

    if (heroAdvImg2 && !isMobile) {
        heroTimeline.to(heroAdvImg2, {
            right: -130,
            duration: 1,
            ease: "power3.out"
        }, '-=2.6').to(heroAdvImg2, {
            x: "-=10",
            repeat: -1,
            yoyo: true,
            duration: 1.6,
            ease: "sine.inOut"
        });
    }

    if (heroAdvImg3 && isMobile) {
        heroTimeline.to(heroAdvImg3, {
            bottom: 0,
            duration: 1,
            ease: "power3.out"
        }).to(heroAdvImg3, {
            x: "-=5",
            repeat: -1,
            yoyo: true,
            duration: 1.6,
            ease: "sine.inOut"
        });
    }

    animateLines();
}

function heroCompanyAnimation() {
    const chartElement = document.querySelector(".hero.companyBg svg");

    if (chartElement) {
        observeVisibility(chartElement, animateChart);
    }
}
function heroAnimation() {
    let mm = gsap.matchMedia();

    const heroImg1 = document.querySelector('.hero .hero-img-1')
    const heroImg2 = document.querySelector('.hero .hero-img-2')
    const heroImg3 = document.querySelector('.hero .hero-img-3')
    const heroCircle = document.querySelector('.hero .circle')
    const heroContent = document.querySelector('.hero .hero-content')

    mm.revert();
    gsap.matchMediaRefresh();

    if (heroImg1) {
        gsap.set(heroImg1, {rotate: -50, left: -650, bottom: 90});

        mm.add("(min-width: 1440px)", () => {
            return gsap.to(heroImg1, {
                rotate: 0, left: -95, bottom: 10, duration: 2,
                ease: "back.out",
                scrollTrigger: {trigger: ".hero", start: "top 80%", toggleActions: "play none restart none"}
            });
        });

        mm.add("(min-width: 768px) and (max-width: 1439px)", () => {
            return gsap.to(heroImg1, {
                rotate: 0, left: -95, bottom: 0, duration: 2,
                ease: "back.out",
                scrollTrigger: {trigger: ".hero", start: "top 80%", toggleActions: "play none restart none"}
            });
        });

        mm.add("(max-width: 767px)", () => {
            gsap.set(heroImg1, {rotate: -50, left: -650, bottom: 90});

            return gsap.to(heroImg1, {
                rotate: 0, left: -45, bottom: 0, duration: 2,
                ease: "back.out",
                scrollTrigger: {trigger: ".hero", start: "top 80%", toggleActions: "play none restart none"}
            });
        });
    }

    if (heroImg2) {
        gsap.set(heroImg2, {rotate: -50, left: -300, bottom: 0});



        mm.add("(min-width: 1440px)", () => {
            return gsap.to(heroImg2, {
                rotate: 0, delay: 0.1, left: 25, bottom: -110, duration: 2.5,
                ease: "back.out",
                scrollTrigger: {
                    trigger: ".hero",
                    start: "top 80%",
                    toggleActions: "play none restart none",
                    once: false
                }
            });
        });

        mm.add("(min-width: 768px) and (max-width: 1439px)", () => {
            return gsap.to(heroImg2, {
                rotate: 0, delay: 0.1, left: 15, bottom: -40, duration: 2.5,
                ease: "back.out",
                scrollTrigger: {
                    trigger: ".hero",
                    start: "top 80%",
                    toggleActions: "play none restart none",
                    once: false
                }
            });
        });

        mm.add("(max-width: 767px)", () => {
            gsap.set(heroImg2, {rotate: -40, left: -100, bottom: -50});

            return gsap.to(heroImg2, {
                rotate: 0, delay: 0.1, left: 15, bottom: -10, duration: 2.5,
                ease: "back.out",
                scrollTrigger: {
                    trigger: ".hero",
                    start: "top 80%",
                    toggleActions: "play none restart none",
                    once: false
                }
            });
        });
    }

    if (heroImg3) {

        gsap.set(heroImg3, {rotate: 40, right: -635, bottom: 0});

        mm.add("(min-width: 1440px)", () => {
            gsap.to(heroImg3, {
                rotate: 10, delay: 0.1, right: -335, bottom: 0, duration: 2.5,
                ease: "back.out",
                scrollTrigger: {
                    trigger: ".hero",
                    start: "top 80%",
                    toggleActions: "play none restart none",
                    once: false
                }
            });
        });

        mm.add("(min-width: 768px) and (max-width: 1439px)", () => {
            gsap.to(heroImg3, {
                rotate: 10, delay: 0.1, right: -215, bottom: 0, duration: 2.5,
                ease: "back.out",
                scrollTrigger: {
                    trigger: ".hero",
                    start: "top 80%",
                    toggleActions: "play none restart none",
                    once: false
                }
            });
        });

        mm.add("(max-width: 767px)", () => {
            gsap.set(heroImg3, {rotate: 80, right: -186, bottom: -30});

            gsap.to(heroImg3, {
                rotate: 10, delay: 0.1, right: -70, bottom: 0, duration: 2.5,
                ease: "back.out",
                scrollTrigger: {
                    trigger: ".hero",
                    start: "top 80%",
                    toggleActions: "play none restart none",
                    once: false
                }
            });
        });
    }
    if (heroCircle) {
        gsap.to(heroCircle, {
            motionPath: {
                start: 0.0,
                path: "#path2",
                align: "#path2",
                autoRotate: true,
                alignOrigin: [0.5, 0.5],
                end: 0.59
            },
            scrollTrigger: {trigger: ".hero", start: "top 80%", toggleActions: "play none restart none", once: false},
            duration: 5, ease: "bounce.out"
        });
    }


    ScrollTrigger.refresh();
}

function heroPubAnimation() {
    const hero = document.querySelector('.hero.publishersBg');
    const heroForeground = document.querySelector('.hero .mountain-foreground');
    const heroMiddle = document.querySelector('.hero .mountain-middle');
    const heroBackground = document.querySelector('.hero .mountain-background');

    gsap.matchMediaRefresh();
    if (window.innerWidth <= 992 && hero) {
        ScrollTrigger.create({
            trigger: hero,
            // pin: true,
            start: "top top",
            end: "+=100%",
            // scrub: true,
        });
    }

    const tl = gsap.timeline();

    if (heroForeground) {
        tl.fromTo(heroForeground,
            {xPercent: -2, yPercent: 3, rotationX: -2, rotationY: 2, scale: 1.02},
            {xPercent: 0, yPercent: 0, rotationX: 0, rotationY: 0, scale: 1, duration: 1.5, ease: "power3.out"}
        );
    }

    if (heroMiddle) {
        tl.fromTo(heroMiddle,
            {xPercent: 2, yPercent: -3, rotationX: 2, rotationY: -2, scale: 1.01},
            {xPercent: 0, yPercent: 0, rotationX: 0, rotationY: 0, scale: 1, duration: 1.5, ease: "power3.out"}, "<"
        );
    }

    if (heroBackground) {
        tl.fromTo(heroBackground,
            {xPercent: -1, yPercent: 1, rotationX: -1, rotationY: 1},
            {xPercent: 0, yPercent: 0, rotationX: 0, rotationY: 0, duration: 1.5, ease: "power3.out"}, "<"
        );
    }

    document.addEventListener("mousemove", (event) => {
        let x = (event.clientX / window.innerWidth - 0.5) * 30;
        let y = (event.clientY / window.innerHeight - 0.5) * 15;

        if (heroForeground) {
            gsap.to(heroForeground, {
                rotationY: x,
                rotationX: y,
                xPercent: x * 0.5,
                yPercent: y * 0,
                scale: 1.05,
                duration: 0.3
            });
        }

        if (heroMiddle) {
            gsap.to(heroMiddle, {
                rotationY: x * 0.8,
                rotationX: y * 0.8,
                xPercent: x * 0.4,
                yPercent: y * 0,
                scale: 1.02,
                duration: 0.3
            });
        }

        if (heroBackground) {
            gsap.to(heroBackground, {
                rotationY: x * 0.5,
                rotationX: y * 0.5,
                xPercent: x * 0.2,
                yPercent: y * 0,
                scale: 1,
                duration: 0.3
            });
        }
    });

    window.addEventListener("scroll", () => {
        if (window.innerWidth <= 992) {
            let scrollY = window.scrollY / window.innerHeight;

            let x = scrollY * 20;
            let y = scrollY * 0;

            if (heroForeground) {
                gsap.to(heroForeground, {
                    rotationY: x,
                    rotationX: y,
                    xPercent: x * 0.5,
                    yPercent: y * 0.5,
                    scale: 1.05,
                    duration: 0.3
                });
            }

            if (heroMiddle) {
                gsap.to(heroMiddle, {
                    rotationY: x * 0.8,
                    rotationX: y * 0.8,
                    xPercent: x * 0.4,
                    yPercent: y * 0.4,
                    scale: 1.02,
                    duration: 0.3
                });
            }

            if (heroBackground) {
                gsap.to(heroBackground, {
                    rotationY: x * 0.5,
                    rotationX: y * 0.5,
                    xPercent: x * 0.2,
                    yPercent: y * 0.2,
                    scale: 1,
                    duration: 0.3
                });
            }
        }
    });

    // window.addEventListener("deviceorientation", (event) => {
    //     let x = event.gamma * 1.5;
    //     let y = event.beta * 1.5;
    //
    //     if (heroForeground) {
    //         gsap.to(heroForeground, {
    //             rotationY: x,
    //             rotationX: y,
    //             xPercent: x * 0.5,
    //             yPercent: y * 0.5,
    //             scale: 1.05,
    //             duration: 0.3
    //         });
    //     }
    //
    //     if (heroMiddle) {
    //         gsap.to(heroMiddle, {
    //             rotationY: x * 0.8,
    //             rotationX: y * 0.8,
    //             xPercent: x * 0.4,
    //             yPercent: y * 0.4,
    //             scale: 1.02,
    //             duration: 0.3
    //         });
    //     }
    //
    //     if (heroBackground) {
    //         gsap.to(heroBackground, {
    //             rotationY: x * 0.5,
    //             rotationX: y * 0.5,
    //             xPercent: x * 0.2,
    //             yPercent: y * 0.2,
    //             scale: 1,
    //             duration: 0.3
    //         });
    //     }
    // });

    ScrollTrigger.refresh();
}

let player;
let videoWasPlayed = false;
// Загружаем YouTube API
const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var addYoutubeEventListener = (function() {

    var callbacks = [];
    var iframeId = 0;

    return function (iframe, callback) {

        // init message listener that will receive messages from youtube iframes
        if(iframeId === 0) {
            window.addEventListener("message", function (e) {

                if(e.origin !== "https://www.youtube.com" || e.data === undefined) return;
                try {
                    var data = JSON.parse(e.data);
                    if(data.event !== 'onStateChange') return;

                    var callback = callbacks[data.id];
                    callback(data);
                }
                catch(e) {}
            });
        }

        // store callback
        iframeId++;
        callbacks[iframeId] = callback;
        var currentFrameId = iframeId;

        // sendMessage to frame to start receiving messages
        if(iframe)
        iframe.addEventListener("load", function () {
            var message = JSON.stringify({
                event: 'listening',
                id: currentFrameId,
                channel: 'widget'
            });
            iframe.contentWindow.postMessage(message, 'https://www.youtube.com');

            message = JSON.stringify({
                event: "command",
                func: "addEventListener",
                args: ["onStateChange"],
                id: currentFrameId,
                channel: "widget"
            });
            iframe.contentWindow.postMessage(message, 'https://www.youtube.com');
        });
    }
})();

const yt = document.getElementById("youtubePlayer");
if (yt) {
    addYoutubeEventListener(document.getElementById("youtubePlayer"), function (e) {
        switch (e.info) {
            case 1:
            case 3:
                videoWasPlayed = true;
                break;
            case 0:
            case 2:
                videoWasPlayed = false;
                break;
        }
    });
}

function onYouTubeIframeAPIReady() {
    player = new YT.Player('youtubePlayer');
}

window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;


function controlAnimation() {
    //temporary disabled animation for the control block
    return true;
    let mm = gsap.matchMedia();

    const control = document.querySelector('.control');
    const controlVideo = document.querySelector('.control .control-video');
    const controlCaption = document.querySelector('.control .control-caption');
    const controlH2 = document.querySelector('.control .control-content h2');

    if (!control || !controlH2 || !controlVideo || !controlCaption) return;

    gsap.matchMediaRefresh();

    mm.add("(min-width: 768px)", () => {
        ScrollTrigger.create({
            trigger: control,
            pin: true,
            start: "top top",
            end: "+=100%",
        });

        gsap.fromTo(controlH2,
            {scale: 2.5, opacity: 1, xPercent: 60, yPercent: -50},
            {
                scale: 1, opacity: 1, xPercent: 0, yPercent: 0, duration: 2, ease: "power3.out",
                scrollTrigger: {
                    trigger: control,
                    start: "top top",
                    end: "+=1000px",
                    scrub: 2,
                }
            }
        );

        gsap.fromTo([controlVideo, controlCaption],
            {opacity: 0, y: 250},
            {
                opacity: 1, y: 0, duration: 2, ease: "power3.out",
                scrollTrigger: {
                    trigger: control,
                    start: "bottom bottom",
                    end: "bottom center",
                    scrub: 2,
                    // markers: { startColor: "blue", endColor: "yellow", fontSize: "14px" }
                }
            }
        );
    });
    mm.add("(max-width: 767px)", () => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: control,
                start: "top 20%",
                end: "+=300px",
                scrub: true,
                // pin: true,
                // markers: {startColor: "green", endColor: "red", fontSize: "14px"}
            }
        });

        tl.fromTo(controlH2,
            {scale: 1.4, opacity: 1, xPercent: 0, yPercent: -50},
            {scale: 1, opacity: 1, xPercent: 0, yPercent: 0, duration: 2, ease: "power3.out"}
        );

        tl.fromTo([controlVideo, controlCaption],
            {opacity: 0, y: 10},
            {opacity: 1, y: 0, duration: 2, ease: "power3.out"}
        );
    });
}


function animateHowWorks() {

    const isMobile = window.innerWidth < 992;
    const items = (isMobile) ? document.querySelectorAll(".how-works-mobile .how-works-item-animate") : document.querySelectorAll(".how-works-pc .how-works-item-animate");

    if (items.length === 0) return;

    gsap.set(items, {opacity: 0, y: 30});

    gsap.to(items, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        stagger: {
            amount: 0.8,
            from: "start",
        },
        scrollTrigger: {
            trigger: isMobile ? ".how-works-mobile" : ".how-works-pc",
            start: "top 90%",
            end: "bottom top",
            scrub: 1,
            toggleActions: "play none none reverse",
        },
    });

}

function animateItems() {
    const sections = document.querySelectorAll(".section");

    sections.forEach(section => {
        const items = section.querySelectorAll(".animate-item");

        if (items.length === 0) return;

        items.forEach((item, index) => {
            gsap.fromTo(
                item,
                {
                    opacity: 0.2,
                    scale: 0.9,
                },
                {
                    opacity: 1,
                    scale: 1,
                    duration: 1.2,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: item,
                        start: `top ${50 + index * 15}%`,
                        end: "top 30%",
                        scrub: 1.5,
                    },
                }
            );
        });
    });
}

function animateContacts() {
    const isMobile = window.innerWidth < 992;
    const img = document.querySelector(".contacts-form-wrap .contacts-form-img");

    if (!img || isMobile) return;

    const contacts = gsap.timeline({paused: false})

    contacts.to(img, {
        x: -300,
        rotate: '-7deg',
        duration: 1,
        ease: "power3.out"
    }).to(img, {
        rotate: '-=2deg',
        repeat: -1,
        yoyo: true,
        duration: 3,
        ease: "sine.inOut"
    });

}

document.addEventListener("DOMContentLoaded", () => {
    const loader = document.querySelector("#loader");

    if (!loader) return;

    setTimeout(() => {
        // гарантированно скрываем лоадер
        loader.classList.remove("show");

        // запускаем анимации, но безопасно
        try { heroAnimation(); } catch (e) { console.error(e); }
        try { animateContacts(); } catch (e) { console.error(e); }
        try { controlAnimation(); } catch (e) { console.error(e); }
        try { heroPubAnimation(); } catch (e) { console.error(e); }
        try { heroAdvAnimation(); } catch (e) { console.error(e); }
        try { animateItems(); } catch (e) { console.error(e); }
        try { heroCompanyAnimation(); } catch (e) { console.error(e); }
        try { animateHowWorks(); } catch (e) { console.error(e); }

        const hash = window.location.hash;
        if (hash === '#faq') {
            const target = document.getElementById('faq');
            if (target) target.scrollIntoView({ behavior: 'smooth' });
        }
    }, 2000);

    // 🔥 FALLBACK — скрыть лоадер по-любому через 8 секунд
    setTimeout(() => {
        if (loader.classList.contains("show")) {
            console.warn("Loader fallback triggered — forced hide.");
            loader.classList.remove("show");
        }
    }, 8000);
});


window.addEventListener("resize", () => {
    // ScrollTrigger.refresh();
    heroAnimation();
    animateContacts();
    controlAnimation();
    heroPubAnimation();
    heroAdvAnimation();
    animateHowWorks();
    ScrollTrigger.refresh();
});

const heroAdv = document.querySelector(".hero.advBg");

if (heroAdv) {
    observeVisibility(heroAdv, isVisible => {
        if (isVisible) {
            heroTimeline.resume();
            startWaveAnimation();
        } else {
            heroTimeline.pause();
            stopWaveAnimation();
        }
    });
}

const control = document.querySelector(".control.section");

if (control) {
    observeVisibility(control, isVisible => {
        if (isVisible) {
            if (player) {
                if (videoWasPlayed) {
                    player.playVideo();
                }
            }
        } else {
            if (player && videoWasPlayed) {
                player.pauseVideo();
                videoWasPlayed = true;
                setTimeout(()=>{videoWasPlayed = true}, 100);
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const questions = document.querySelectorAll('.faq-item-question');

    if (!questions || questions.length === 0) return;

    questions.forEach((question) => {
        if (!question) return;

        question.addEventListener('click', function () {
            const currentItem = question.closest('.faq-item');

            if (!currentItem) return;

            // Закрыть все открытые
            document.querySelectorAll('.faq-item.open').forEach((item) => {
                if (item !== currentItem) {
                    item.classList.remove('open');
                    const answer = item.querySelector('.faq-item-answer');
                    if (answer) {
                        answer.style.maxHeight = null;
                    }
                }
            });

            const answer = currentItem.querySelector('.faq-item-answer');

            if (currentItem.classList.contains('open')) {
                currentItem.classList.remove('open');
                if (answer) answer.style.maxHeight = null;
            } else {
                currentItem.classList.add('open');
                if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
            }
        });
    });
});



